import "slick-slider";

jQuery(document).ready(($) => {

    $('.magazine-slider').slick({
        variableWidth: true,
        rtl: true,
        slidesToScroll: 1,
        arrows: true,
        lazyLoad: 'progressive',
        nextArrow: "<div class='slider-arrow slider-arrow-left'><img src='/app/themes/sport1/public/images/left-arrow.svg' alt=''></div>",
        prevArrow: "<div class='slider-arrow slider-arrow-right'><img src='/app/themes/sport1/public/images/right-arrow.svg' alt=''></div>",
        responsive: [
            {
                breakpoint: 769,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    arrows: false,
                    dots: true
                }
            },
            {
                breakpoint: 376,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    variableWidth: false,
                    autoplay: true,
                    autoplaySpeed: 4000,
                    dots: true
                }
            }
        ]
    });

    $('.square-slider').slick({
        variableWidth: true,
        rtl: true,
        slidesToScroll: 1,
        arrows: true,
        lazyLoad: 'progressive',
        nextArrow: "<div class='slider-arrow slider-arrow-left'><img src='/app/themes/sport1/public/images/left-arrow.svg' alt=''></div>",
        prevArrow: "<div class='slider-arrow slider-arrow-right'><img src='/app/themes/sport1/public/images/right-arrow.svg' alt=''></div>",
        responsive: [
            {
                breakpoint: 769,
                settings: {
                    arrows: false,
                    dots: true
                }
            },
            {
                breakpoint: 376,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    arrows: false,
                    variableWidth: true,
                    infinite: false,
                    nextArrow: null,
                    prevArrow: null,
                }
            }
        ]
    });


    $('.magazine-article > a').on('click', function () {
        let label = $('h4', this).text();

        sport1Analytics.sendEvent('home-page', 'mag-articles-click', label);
    });

    $('.penalty-area-article > a').on('click', function () {
        let label = $('h4', this).text();

        sport1Analytics.sendEvent('home-page', 'barehava-click', label);
    });

    $('.homepage-section-magazine .view-all').on('click', function () {
        sport1Analytics.sendEvent('home-page', 'all-mag-articles-click', 'magazine');
    });

    $('.homepage-section-square .view-all').on('click', function () {
        sport1Analytics.sendEvent('home-page', 'all-barehava-click', 'barehava');
    });

});